<template>
  <section class="disclaimer-section">
    <div class="section__container">
      <h2 class="section__title">
        What to expect after joining
        <span style="color: var(--accent-red)">our Talent Pool?</span>
      </h2>
      <div class="cards-container">
        <div class="card" v-for="(data, index) in dis" :key="index">
          <img
            class="card__icon"
            :src="require(`@/assets/img/${data.icon}`)"
            alt=""
          />
          <p class="card__text">{{ data.text }}</p>
        </div>
      </div>
    </div>
    <div class="callout__container">
      <div class="callout">
        <div class="callout__body">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="6">
              <h3 class="callout__title text-center text-lg-start">
                What <span style="color: var(--accent-red)">NOT</span> to Expect
              </h3>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="6"
              class="d-flex align-center justify-center text-center text-lg-start"
            >
              <div>
                <p class="callout__sub-title">
                  Immediate job placement/interviews
                </p>
                <p class="callout__description">
                  Matching your skill sets with potential clients’ needs can
                  take time. We ask you to be patient with us.
                </p>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="callout__footer">
          <p class="callout__footer-text">
            Do not leave your current job until our clients hire you.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DisclaimerSection',
  data: () => ({
    dis: [
      {
        icon: 'd1.png',
        text: 'Access to training and enablement programs to augment your skills.',
      },
      {
        icon: 'd2.png',
        text: 'In-person and virtual workshops to review and build your resume.',
      },
      {
        icon: 'd4.png',
        text: 'Interviews with potential clients after they express interest in speaking with you.',
      },
      {
        icon: 'd5.png',
        text: 'Access to our online professional community.',
      },
      {
        icon: 'd3.png',
        text: 'Networking events',
      },
    ],
  }),
};
</script>

<style scoped>
.disclaimer-section {
  text-align: left;
  padding-top: 3rem;
  background-color: var(--light-1);
}

.section__title {
  font-size: 2.25rem !important;
  width: 80%;
  /* max-width: rem; */
  line-height: 140%;
  font-family: 'DM Sans Bold', sans-serif;
  margin: 4rem auto;
  text-align: center;
}

.cards-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 2rem;
  margin-top: 2rem;
  padding: 0 0 5rem 0;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  margin-bottom: 1rem;
  padding: 3rem 4rem;
  width: 100%;
  background-color: #fff;
  border-radius: 0.4rem;
  text-align: center;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.02);
}

.card__icon {
  margin-bottom: 1rem;
  width: 3rem;
  height: 3rem;
}

.card__text {
  font-family: 'Outfit Medium', sans-serif;
}

.callout__container {
  background-color: #ff686014;
  max-width: 1920px;
  margin: 0 auto;
}

.callout {
  border: 3px solid var(--accent-red);
  margin-block: 2rem;
  max-width: 1280px;
  margin: 0 auto;
}

.callout__body {
  padding: 2rem;
}

.callout__title {
  font-size: clamp(26px, 5vw, 44px);
  font-family: 'DM Sans Bold', sans-serif;
}

.callout__sub-title {
  font-size: 1.25rem;
  line-height: 1.25;
  font-family: 'DM Sans Bold', sans-serif;
}

.callout__description {
  font-family: 'Manrope Medium', sans-serif;
  margin-top: 1rem;
}

.callout__footer {
  background-color: var(--accent-red);
  color: var(--light-1);
  padding: 0.5rem;
  text-align: center;
  font-size: 1.25rem;
}
@media only screen and (max-width: 768px) {
  .callout__title {
    max-width: 100%;
  }
  .callout__container {
    padding: 5rem 2rem;
  }
}
@media only screen and (min-width: 768px) {
  .cards-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    margin-top: 2rem;
    padding: 0 0 5rem 0;
  }
  .callout__title {
    max-width: 100%;
  }

  .callout__container {
    padding: 5rem 5rem;
  }
}

@media only screen and (min-width: 1280px) {
  .cards-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    margin-top: 2rem;
    padding: 0 0 5rem 0;
  }
  .callout__title {
    max-width: 15rem;
  }
  .callout__container {
    padding: 5rem 7.5rem;
  }
}
</style>
